export default __webpack_public_path__ + "static/media/avatar.00a23653.png";